import React from "react";
import { RightOutlined } from "@ant-design/icons";
import { renderArticle } from "./guideHelpers";
import { formatUpdateDate } from "./productUpdates";
import { useGuideLinks } from "./UserGuide";

const UpdateEntry = ({ update, article, onLinkClick, onOpenArticle }) => (
   <li className="help-update">
      <div className="help-update__meta">
         <span className={`help-update__tag help-update__tag--${update.tag.toLowerCase()}`}>
            {update.tag}
         </span>
         <time dateTime={update.date}>{formatUpdateDate(update.date)}</time>
      </div>
      <h4 className="help-update__title">{update.title}</h4>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
         className="help-update__body"
         onClick={onLinkClick}
         dangerouslySetInnerHTML={{ __html: renderArticle(update.body) }}
      />
      {article && (
         <button
            type="button"
            className="help-update__more"
            onClick={() => onOpenArticle(article.id)}
         >
            Learn more <RightOutlined />
         </button>
      )}
   </li>
);

/** Drawer view: what has shipped, newest first. */
const WhatsNew = ({ updates, articles, onOpenArticle, onClose }) => {
   const handleLinkClick = useGuideLinks({ articles, onOpen: onOpenArticle, onClose });

   if (updates.length === 0) {
      return <p className="help-center__no-results">Nothing new yet. Check back soon.</p>;
   }

   return (
      <ol className="help-updates">
         {updates.map((update) => (
            <UpdateEntry
               key={update.id}
               update={update}
               article={update.article && articles.find((item) => item.id === update.article)}
               onLinkClick={handleLinkClick}
               onOpenArticle={onOpenArticle}
            />
         ))}
      </ol>
   );
};

export default WhatsNew;
